import styled from "styled-components";

export const Style = styled.div`
  min-height: 14px;

  .icon-row {
    display: flex;
    justify-content: flex-end;
    font-size: 10px;
    animation: .6s fade forwards;

    &.no-animation {
      animation: unset;
    }

    &.closed {
      animation: .6s fadeOut forwards;
    }

    svg {
      width: 14px;
      height: 14px;
      color: #98A2B3;
      cursor: pointer;
    }
  }

  @keyframes fade { 0% { opacity: 0; } 100% { opacity: 1; } }
  @keyframes fadeOut { 0% { opacity: 1; } 100% { opacity: 0; } }

  .main-cont {
    padding: 8px 12px;
    background: #FAFAFA;
    border-radius: 4px;
    display: flex;
    gap: 12px;
    margin-bottom: var(--size);

    .anticon {
      align-items: baseline;
    }

    h5 {
      color: #344054;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0px;
      line-height: 20px;
    }

    .close-icon {
      cursor: pointer;

      svg {
        width: 10px;
        color: #98A2B3;
      }
    }
  }

  .animation-cont {
    transition: .6s max-height, .6s opacity;
    overflow: hidden;

    &.no-transition {
      transition: unset;
    }
  }
`;
